import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Backdrop, CircularProgress } from '@mui/material';

import { useAuth } from '../hooks/useAuth';
import { routes } from '../../../router/routes';

interface ProtectedRouteProps {
  children: React.ReactNode;
  action: string; // named after casl prop names
  path: string; // named after casl prop names
}

export const ProtectedRoute = ({ children, action, path }: ProtectedRouteProps) => {
  const { ability } = useAuth();
  const [isLoadingAbilities, setIsLoadingAbilities] = useState(true);

  useEffect(() => {
    let loadingTimeout: NodeJS.Timeout | undefined;

    if (isLoadingAbilities) {
      loadingTimeout = setTimeout(() => {
        setIsLoadingAbilities(false);
      }, 1000);
    }

    return () => {
      clearTimeout(loadingTimeout);
    };
  }, []);

  if (isLoadingAbilities) {
    return (
      <Backdrop sx={{ color: (theme) => theme.palette.common.white, zIndex: (theme) => theme.zIndex.drawer + 1 }} open>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  return ability.can(action, path) ? children : <Navigate to={routes.error404} />;
};
